import { render, staticRenderFns } from "./TodoWidget.vue?vue&type=template&id=5ce54551&"
import script from "./TodoWidget.vue?vue&type=script&lang=js&"
export * from "./TodoWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports